import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    width: 100%;
    height: 4.5rem;
    /* padding: 0 1rem; */
    padding: 1rem;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${({theme})=>theme.colors.__gray[300]};
    background: ${({theme})=>theme.colors.__gray[200]};

    .actions__{
        display: flex;
        gap: 1rem;
        width: 50%;
        justify-content: flex-end;
    }
`;

export const CloseAside = styled.div`
    display: flex;
    width: 2.5rem;
    height: 2.5rem;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    cursor: pointer;
    font-size: 4rem;
    &:hover{
        background: ${({theme})=>theme.colors.__gray[250]};
    }
`;

export const SoundControls = styled.div`
    display: flex;
    width: 2.5rem;
    height: 2.5rem;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    cursor: pointer;
    &:hover{
        background: ${({theme})=>theme.colors.__gray[250]};
    }
`;


